import firebase from './firebaseIndex';
import { loginDestination } from '../routing/navigation';
import { authError, clearSessionCache, writeStored } from './authSession';

async function attempt(setErrors, operation) {
  setErrors([]);
  try { return await operation(); }
  catch (error) {
    setErrors([authError(error)]);
    throw error;
  }
}

// Session state is maintained by AuthProvider's single Firebase observer.
export const authMethods = {
  signinGoogle: setErrors => attempt(setErrors, () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  }),

  signin: (email, password, setErrors) => attempt(setErrors,
    () => firebase.auth().signInWithEmailAndPassword(email.trim(), password)),

  signup: (email, password, license, setErrors) => attempt(setErrors, async () => {
    const result = await firebase.auth().createUserWithEmailAndPassword(email.trim(), password);
    await firebase.firestore().collection('users').doc(result.user.uid).set({
      email: result.user.email,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    }, { merge: true });
    return result;
  }),

  signout: setErrors => attempt(setErrors, async () => {
    await firebase.auth().signOut();
    clearSessionCache(true);
  }),

  forgotPassword: (email, setErrors) => attempt(setErrors,
    () => firebase.auth().sendPasswordResetEmail(email.trim())),

  sendEmailLink: (email, setErrors) => attempt(setErrors, async () => {
    const cleanEmail = email.trim();
    let url = process.env.REACT_APP_EMAIL_LINK_REDIRECT_URL || `${window.location.origin}/finishLogin`;
    const destination = loginDestination();
    if (destination !== '/') {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('next', destination);
      url = target.href;
    }
    await firebase.auth().sendSignInLinkToEmail(cleanEmail, { url, handleCodeInApp: true });
    writeStored('emailForSignIn', cleanEmail);
  }),

  completeEmailLink: (email, link, setErrors) => attempt(setErrors, async () => {
    if (!firebase.auth().isSignInWithEmailLink(link)) {
      const error = new Error('Invalid sign-in link');
      error.code = 'auth/invalid-action-code';
      throw error;
    }
    const result = await firebase.auth().signInWithEmailLink(email.trim(), link);
    try { window.localStorage.removeItem('emailForSignIn'); } catch (_) {}
    return result;
  }),
};
